export const VALIDATE_OTP_REQUEST = 'VALIDATE_OTP_REQUEST';
export const VALIDATE_OTP_SUCCESS = 'VALIDATE_OTP_SUCCESS';
export const VALIDATE_OTP_FAILURE = 'VALIDATE_OTP_FAILURE';

export const VALIDATE_AUTH_REQUESTS = 'VALIDATE_AUTH_REQUEST';
export const VALIDATE_AUTH_SUCCESS = 'VALIDATE_AUTH_SUCCESS';
export const VALIDATE_AUTH_FAILURE = 'VALIDATE_AUTH_FAILURE';

export const VALIDATE_FACE_AUTH_REQUESTS = 'VALIDATE_FACE_AUTH_REQUEST';
export const VALIDATE_FACE_AUTH_SUCCESS = 'VALIDATE_FACE_AUTH_SUCCESS';
export const VALIDATE_FACE_AUTH_FAILURE = 'VALIDATE_FACE_AUTH_FAILURE';

export const SUBMIT_UPDATE_REQUEST = 'SUBMIT_UPDATE_REQUEST';
export const SUBMIT_UPDATE_SUCCESS = 'SUBMIT_UPDATE_SUCCESS';
export const SUBMIT_UPDATE_FAILURE = 'SUBMIT_UPDATE_FAILURE';

export const GET_UPDATE_REQUEST = 'GET_UPDATE_REQUEST';
export const GET_UPDATE_SUCCESS = 'GET_UPDATE_SUCCESS';
export const GET_UPDATE_FAILURE = 'GET_UPDATE_FAILURE';

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';


export const PARTNER_INFO_REQUEST = 'PARTNER_INFO_REQUEST';
export const PARTNER_INFO_SUCCESS = 'PARTNER_INFO_SUCCESS';
export const PARTNER_INFO_FAILURE = 'PARTNER_INFO_FAILURE';

export const VERIFY_REGISTRATION = 'VERIFY_REGISTRATION';
export const VERIFY_REGISTRATION_SUCCESS = 'VERIFY_REGISTRATION_SUCCESS';
export const VERIFY_REGISTRATION_FAILURE = 'VERIFY_REGISTRATION_FAILURE';


export const FACE_AUTH_REQUEST = 'FACE_AUTH_REQUEST';
export const FACE_AUTH_SUCCESS = 'FACE_AUTH_SUCCESS';
export const FACE_AUTH_FAILURE = 'FACE_AUTH_FAILURE';

export const PACKET_STATUS_REQUEST = 'PACKET_STATUS_REQUEST';
export const PACKET_STATUS_SUCCESS = 'PACKET_STATUS_SUCCESS';
export const PACKET_STATUS_FAILURE = 'PACKET_STATUS_FAILURE';

export const RESEND_STATUS_REQUEST = 'RESEND_STATUS_REQUEST';
export const RESEND_STATUS_SUCCESS = 'RESEND_STATUS_SUCCESS';
export const RESEND_STATUS_FAILURE = 'RESEND_STATUS_FAILURE';

export const LOCATION_REQUEST = 'LOCATION_REQUEST';
export const LOCATION_SUCCESS = 'LOCATION_SUCCESS';
export const LOCATION_FAILURE = 'LOCATION_FAILURE';

export const CARD_PROCESSOR_DATA_REQUEST = 'CARD_PROCESSOR_DATA_REQUEST';
export const CARD_PROCESSOR_DATA_SUCCESS = 'CARD_PROCESSOR_DATA_SUCCESS';
export const CARD_PROCESSOR_DATA_FAILURE = 'CARD_PROCESSOR_DATA_FAILURE';

export const CONTACT_OTP_GENERATE_REQUEST = 'CONTACT_OTP_GENERATE_REQUEST';
export const CONTACT_OTP_GENERATE_SUCCESS = 'CONTACT_OTP_GENERATE_SUCCESS';
export const CONTACT_OTP_GENERATE_FAILURE = 'CONTACT_OTP_GENERATE_FAILURE';
export const CONTACT_OTP_VALIDATE_REQUEST = 'CONTACT_OTP_VALIDATE_REQUEST';
export const CONTACT_OTP_VALIDATE_SUCCESS = 'CONTACT_OTP_VALIDATE_SUCCESS';
export const CONTACT_OTP_VALIDATE_FAILURE = 'CONTACT_OTP_VALIDATE_FAILURE';
export const CONTACT_OTP_RESET = 'CONTACT_OTP_RESET';
